import {useNavigate} from "react-router-dom";
import React, {useEffect, useMemo, useState} from "react";
import Cookies from "js-cookie";
import AppHeader from "../header/AppHeader";
import {FormWrapper} from "./components/utils/form/FormWrapper";
import {Tabs, TabsValue} from "@mantine/core";
import {Container} from "react-bootstrap";
import {ParticipantTable} from "./components/utils/table/ParticipantTable";
import {Role, ServiceCenter} from "../../types/domain";
import UseraccountService from "../../services/useraccount.service";
import {GroupTable} from "./components/utils/table/GroupTable";
import {UserTable} from "./components/utils/table/UserTable";

/**
 * Management page
 * @author NSC, KMU
 */
export default function Management() {
    const navigate = useNavigate();
    const [userData, setUserData] = useState<{ userRole: Role | null, userServiceCenters: ServiceCenter[] }>({
        userRole: null,
        userServiceCenters: []
    });
    const [activeTab, setActiveTab] = useState('participants');
    const memoizedUserData  = useMemo(
        () => userData,
        [userData]
    );


    /* Checks access of user */
    useEffect(() => {
        if (!Cookies.get('username')) {
            navigate('login', {replace: true});
            return;
        }

        UseraccountService.getByName(Cookies.get('username')!)
            .then((response: any) => {
                const dbUser = response.data;
                setUserData({
                    userRole: dbUser.role,
                    userServiceCenters: dbUser.serviceCenters
                });
                if (!dbUser.role || (dbUser.role.name !== 'Admin' && dbUser.role.name !== 'DSS Leiter*in')) {
                    navigate('/home', {replace: true});
                }
            })
            .catch(console.log)
    }, [navigate]);


    /**
     * Handle tab change
     * @param value new tab value
     */
    const handleTabChange = (value: TabsValue) => {
        if (value !== null) {
            setActiveTab(value); // value is string here
        }
    };


    return (
        <div>
            <AppHeader showStartpageIcon={false} showNewPlanIcon={false}
                       showUserIcon={true} showHomeIcon={false} showBigLogo={false}/>
            <Container className="app-content-container">
                <FormWrapper title="Management">
                    <Tabs value={activeTab} onTabChange={value => handleTabChange(value)}>
                        <Tabs.List>
                            <Tabs.Tab value="participants">Teilnehmer*innen</Tabs.Tab>
                            <Tabs.Tab value="groups">Trainingsgruppen</Tabs.Tab>
                            <Tabs.Tab value="trainers">Trainer*innen</Tabs.Tab>
                        </Tabs.List>
                        <Tabs.Panel value="participants">
                            <ParticipantTable userData={memoizedUserData} tabValue={activeTab}/>
                        </Tabs.Panel>
                        <Tabs.Panel value="groups">
                            <GroupTable userData={memoizedUserData} tabValue={activeTab} />
                        </Tabs.Panel>
                        <Tabs.Panel value="trainers">
                            <UserTable userData={memoizedUserData} tabValue={activeTab} />
                        </Tabs.Panel>
                    </Tabs>
                </FormWrapper>
            </Container>
        </div>
    )
}